import React, { useState, useContext } from 'react'
import { IconButton, Menu, MenuItem, Divider   } from '@mui/material'
import { MoreVert, Edit, Delete, Article, Replay } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import SnackBarContext from '../context/SnackBarContext'

type DataRowMenuProps = {
  rowId: any,
  editModeHandler?: Function,
  deleteHandler?: Function,
  viewLink?: string | undefined,
  editAction?: Function,
  row?: any,
  resendUserInvitationHandler? : Function,
  dataType: string,
}

export const DataRowMenu = ({ rowId, editModeHandler, deleteHandler, resendUserInvitationHandler, viewLink, editAction, row, dataType='standard' }: DataRowMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const { toggleSnackbar } = useContext(SnackBarContext);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleResendInvite = () => {
    if (resendUserInvitationHandler) {
      resendUserInvitationHandler(rowId);
      toggleSnackbar("Resend Invite successful", "success");
      handleClose();
      setTimeout(() => {
        toggleSnackbar("Resend Invite successful", "success");
      }, 3000);
    }
  };

  const viewURL = (viewLink) ? `${viewLink}/${rowId}` : `${rowId}`
  return <>
    <IconButton
      id={`more-button-${rowId}`}
      aria-label='actions'
      aria-controls={open ? 'long-menu' : undefined}
      aria-expanded={open ? 'true' : undefined}
      aria-haspopup="true"
      onClick={handleClick}
    >
      <MoreVert color='secondary' />
    </IconButton>
    <Menu
      id={rowId}
      MenuListProps={{
        'aria-labelledby': `more-button-${rowId}`,
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
    > 
      {resendUserInvitationHandler ? 
           <MenuItem key={`resend-invite-${rowId}`} onClick={handleResendInvite}>
           <Replay color="inherit" sx={{ marginRight: 1 }} />
           Resend Invite
         </MenuItem>
        : null }
      {editModeHandler ?
        <MenuItem
          key={`edit-${rowId}`}
          onClick={() => editModeHandler(rowId)}
        >
          <Edit color='inherit' sx={{ marginRight: 1 }} /> 
          Edit
        </MenuItem>
        : (editAction)
          ?
          <MenuItem
            key={`edit-${rowId}`}
            onClick={() => editAction(row)}
          >
            <Edit color='inherit' sx={{ marginRight: 1 }} />
            Edit
          </MenuItem>
          : null
      }
      {dataType === 'standard' ? 
      <MenuItem
        key={`view-${rowId}`}
        onClick={() => navigate(viewURL)}>
        <Article color='inherit' sx={{ marginRight: 1 }} />
        View
      </MenuItem>
      : null }
      {deleteHandler ? <div>
        <Divider />
        <MenuItem
          key={`delete-${rowId}`}
             onClick={() => {
                deleteHandler(rowId);
                handleClose();
              }}>
          <Delete color='inherit' sx={{ marginRight: 1 }} />
          Delete{dataType === 'invitation' ? ' Invite' : '' }
        </MenuItem>
      </div>
        : null}
    </Menu>
  </>
}